import type {
  TCategoryName,
  TSessionBase,
  TSurveyAnswer,
  TSurveyQuestion,
  TSurveyUserSessionStats,
  TUserBase,
} from "@/types"
import { api } from "./api"
import type { IAPIParams } from "./types"
import { generateAPIResource } from "./utils"

// Survey APIs
export const answersAPI = generateAPIResource<TSurveyAnswer>((sessionId) => `/survey/${sessionId}/answers`)
export const questionsAPI = generateAPIResource<TSurveyQuestion>("/survey/questions")
export const surveyStatsUserSessionsAPI = generateAPIResource<TSurveyUserSessionStats>(
  "/survey/stats/user_sessions",
  {},
)

export type TFeedbackScore = {
  peer_id: string
  score: number | null
  session_id: string
}

export async function fetchAPIFeedbackScores(params: IAPIParams = {}) {
  const { data } = await api.get<TFeedbackScore[]>(`/survey/stats/feedback`, {
    params,
  })
  return data
}

export type TReviewStats = {
  peer: TUserBase
  session: TSessionBase
  stats: {
    [key in TCategoryName]: {
      count: number
      score: number | null
    }
  }
}

export async function createAPISurveyReminder({
  id,
  usersessionId,
  message,
}: {
  id: string
  usersessionId: string
  message: string
}) {
  const res = await api.post(`/survey/session/${id}/remind/${usersessionId}`, message, {
    headers: { "Content-Type": "application/json" },
  })
  return res
}

export async function createAPISurveyPeersNotify(id: string, body: { visibility: "public" | "managers" | "admins" }) {
  const res = await api.post(`/survey/session/${id}/peers_notify`, body)
  return res
}
